export default "__VITE_ASSET__DmGaDSUU__"